import { addToSessionStore, getFromSessionStore } from './sessionStore'
// import * as Y from 'yjs'
// import { WebsocketProvider } from 'y-websocket'
//
// const ydoc = new Y.Doc()
// const websocketProvider = new WebsocketProvider('wss://' + window.location.hostname + '/BotServices/yjs', 'OxygenSessions', ydoc);
const locationObj =  Object.assign({}, window.location);
const urlParams = new URLSearchParams(locationObj.search);
const userAgent = urlParams.get('userAgent');
const urlMeetingContext = urlParams.get('MeetingContext');
const urlDeskContext = urlParams.get('DeskContext');
const windowMode = urlParams.get('window');
const overlayMode = urlParams.get('overlay');
const Env = urlParams.get('env');
const appSync = [];
var defMeetingContext = null;
var defDeskContext = null;

if (urlParams.has('originalURL')) {
  const originalURL = decodeURIComponent(urlParams.get('originalURL'));
  window.history.pushState({}, '', originalURL);
  console.log("Updated URL", originalURL);
}

//console.log("Def Meeting Context : ", urlMeetingContext);
if(urlMeetingContext) {
  defMeetingContext = JSON.parse(urlMeetingContext);
  //console.log("defMeetingContext : ", defMeetingContext.MeetingRootId);
}

if(urlDeskContext) {
  defDeskContext = JSON.parse(urlDeskContext);
  //console.log("defDeskContext : ", defDeskContext.DeskId);
}

(window.defDeskContext) ? defDeskContext = window.defDeskContext : defDeskContext = defDeskContext;

//console.log("defDeskContext", defDeskContext, window.defDeskContext);

const sessionUrl = '/OxygenSessions/sessions'
//const oxygen = window.LivingScript_0070;
var config = {};
var refreshContexts = null;
getFromSessionStore({item : 'contexts'}, (err, contexts) => {
  refreshContexts = contexts;
});

/* Load ICE information for communication System */
getIceInfo();

getFromSessionStore({item : 'serverinfo'}, (err, serverinfo) => {
  if(serverinfo) {
    if(window.botStore) {
      window.botStore.serverinfo = serverinfo;
      window.botStore.location = locationObj;
      window.botStore.appInfo.Name = userAgent || 'SimpliaWebApp';
      window.botStore.env = Env || 'Production';
      /* Overlay Settings */
      if(overlayMode) {
        window.botStore.setSettings({name : 'Overlay', value : overlayMode});
      }

      getFromSessionStore({item : 'attributions'}, (err, attributions) => {
        if(attributions && attributions.length > 0) {
          window.botStore.setAttributions(attributions);
          //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
          //addMeetingMenu(primaryAccount, () => {});
        }
      });
    } else {
      window.addEventListener('botServicesLoaded', (e) => {
        window.botStore.serverinfo = serverinfo;
        window.botStore.location = locationObj;
        window.botStore.appInfo.Name = userAgent || 'SimpliaWebApp';
        window.botStore.env = Env || 'Production';
        /* Overlay Settings */
        if(overlayMode) {
          window.botStore.setSettings({name : 'Overlay', value : overlayMode});
        }
        
        getFromSessionStore({item : 'attributions'}, (err, attributions) => {
          if(attributions && attributions.length > 0) {
            window.botStore.setAttributions(attributions);
            //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
            //addMeetingMenu(primaryAccount, () => {});
          }
        });
      });
    }
  } else {
    SetServerInfo();
  }
});

function SetServerInfo() {
  httpRequest({
    method : 'GET',
    type : "application/json",
    url : '/CommunicationClient/System/ServerSide/getServerInfo',
    data : {}
  }, (err, res) => {
    //console.log("CommServeInfo : ", res);
    if(window.botStore) {
      window.botStore.serverinfo = JSON.parse(res);
      window.botStore.location = locationObj;
      window.botStore.appInfo.Name = userAgent || 'SimpliaWebApp';
      addToSessionStore({item : 'serverinfo'});
       /* Overlay Settings */
      if(overlayMode) {
        window.botStore.setSettings({name : 'Overlay', value : overlayMode});
      }
      getFromSessionStore({item : 'attributions'}, (err, attributions) => {
        if(attributions && attributions.length > 0) {
          window.botStore.setAttributions(attributions);
          //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
          //addMeetingMenu(primaryAccount, () => {});
        }
      });
    } else {
      window.addEventListener('botServicesLoaded', (e) => {
        window.botStore.serverinfo = JSON.parse(res);
        window.botStore.location = locationObj;
        window.botStore.appInfo.Name = userAgent || 'SimpliaWebApp';
        addToSessionStore({item : 'serverinfo'});
         /* Overlay Settings */
        if(overlayMode) {
          window.botStore.setSettings({name : 'Overlay', value : overlayMode});
        }
        getFromSessionStore({item : 'attributions'}, (err, attributions) => {
          if(attributions && attributions.length > 0) {
            window.botStore.setAttributions(attributions);
            //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
            //addMeetingMenu(primaryAccount, () => {});
          }
        });
      });
    }  
  });
}

function getIceInfo() {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/getIceInfo',
    data : {}
  }, (err, result) => {
    //console.log("getIceInfo : ", result);
    if(result) {
      window.botStore.setIceInfo(JSON.parse(result));
    }
  });
}

if((window.LivingScript_0070 && window.LivingScript_0070.sessionInit) || (window.LivingScript_0070 && window.LivingScript_0070.context &&  window.LivingScript_0070.context.sessionId)) {
  //console.log("botSession Already Loaded");
  sessionRequest((err, result) => {
    //console.log("Session Request Result DONE : ", result);
    if(window.CommLib) {
      getFromSessionStore({item : 'serverConfig'}, (err, serverConfig) => {
        if(serverConfig) {
          config = serverConfig;
          window.botStore.serverConfig = config;
        } else {
          config = JSON.parse(result);
          window.botStore.serverConfig = config;
          addToSessionStore({item : 'serverConfig'});
        }
        window.CommApp = new CommLib(config);
        window.CommApp.init({Version : '2.0'},()=>{});
        if(window.BotServices) {
          window.BotServices.callManagerInit(config);
        } else {
          window.addEventListener('botServicesLoaded', (e) => {
            window.BotServices.callManagerInit(config);
          });
        }
      });
    }
  });
} else {
    window.addEventListener('sessionInit', (e) => {
      //console.log("Got Event botSession");
      sessionRequest((err, result) => {
        //console.log("Session Request Result DONE : ", result);
        if(window.CommLib) {
          getFromSessionStore({item : 'serverConfig'}, (err, serverConfig) => {
            if(serverConfig) {
              config = serverConfig;
              window.botStore.serverConfig = config;
            } else {
              config = JSON.parse(result);
              window.botStore.serverConfig = config;
              addToSessionStore({item : 'serverConfig'});
            }
            window.CommApp = new CommLib(config);
            window.CommApp.init({Version : '2.0'},()=>{});
            window.BotServices.callManagerInit(config);
          });
        }
      });
    });
}

window.addEventListener('LivingScriptInit', (e) => {
  //console.log("Got LivingScriptInit URL Context : ", window.LivingScript_0070.context.urlContext);
  //let initailContext = {};

  if(window.LivingScript_0070.context.urlContext) {
    let initialContext = window.LivingScript_0070.context.urlContext;

    if (typeof window.LivingScript_0070.context.urlContext === "string") {
      try {
          initialContext = JSON.parse(window.LivingScript_0070.context.urlContext);
      } catch(e) {
          console.log("Invalid urlContext");
      }
    }

    //console.log("Got LivingScriptInit URL Context Parsed", typeof initialContext);
    if(initialContext.onLoad && initialContext.onLoad.length > 0) {
      initialContext.onLoad.forEach((action) => {
        console.log("onLoad Action => ", action);
        if(action.open) {
          //console.log("onLoad Action ", action);
          if(window.devStore && window.devStore.rootMenu) {
            if(window.devStore.rootMenu[0]) {
              window.BotServices.PullRootMenu(window.devStore.rootMenu[0], (err, viewPortInfo) => {
                //console.log("Url Context Pulled Viewport : ", viewPortInfo);
                if(action.child) {
                  openChildPanel({ClientID : viewPortInfo.ClientRowID, DisplayName : action.child.DisplayName, Termination : action.child.Termination}, () => {});
                }
              });
            } else {
              //console.log("Add and load rooutmenu for Onload");
              /*
              let grantItem = window.LivingScript_0070.context.grantItem;
              let meetingObj = window.LivingScript_0070.context.MeetingContext;

              window.devStore.addMeetingIndex(meetingObj.MeetingRootId);
              window.devStore.addMeetingIndex(meetingObj.MeetingParentId);
            
              let parentIndex = window.devStore.getMeetingIndex(meetingObj.MeetingRootId);
              let localIndex = window.devStore.getMeetingIndex(meetingObj.MeetingParentId);

              let menuObj = {
                ParentIndex : parentIndex,
                LocalIndex : localIndex,
                MeetingRootDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingRootDN,
                MeetingParentDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingParentDN,
                MeetingRootID : meetingObj.MeetingRootId,
                MeetingParentID : meetingObj.MeetingParentId,
                MeetingRole : meetingObj.MeetingParentRole,
                PrettyURL : null,
                Path : meetingObj.MeetingRootId,
                LeftRole : grantItem.GrantLeftR,
                RightRole : grantItem.GrantRightR,
                LeftID : grantItem.GrantLeftID,
                RightID : grantItem.GrantRightID,
                LeftDN : grantItem.GrantLeftDN,
                RightDN : grantItem.GrantRightDN,
                DisplayStatus : null,
                ClientRowID : null,
                PermanentLink : true,
                MeetingContext : meetingObj,
                Type : 'Parent'
              };

              window.devStore.addRootMenu(menuObj);
              window.BotServices.PullRootMenu(menuObj, (err, viewPortInfo) => {
                console.log("Url Context Pulled Viewport : ", viewPortInfo);
                if(action.child) {
                  openChildPanel({ClientID : viewPortInfo.ClientRowID, DisplayName : action.child.DisplayName, Termination : action.child.Termination}, () => {});
                }
              });*/
            }
          } else {
            console.log("window.devStore.rootMenu not ready");
          }
        }

        //console.log("onLoad Action", action);
        if(action.alert) {
          //console.log("onLoad Action Alert : ", action.alert);
          let Client = window.botStore.getClientByID(window.LivingScript_0070.context.clientNodeId);
          window.BotServices.openAlert({Event : action.alert, Client : Client}, ()=>{});
        }

        if(action.signup && window.LivingScript_0070.context.attribution === undefined) {
          let simpliaLoginModal = document.getElementById('simplia-Signin');
          simpliaLoginModal._instance.exposed.modalOpen();
          window.LivingScript_0070.context.onLoadaction = action;
        }
      });
    }

    if(initialContext.Streamer) {
      let streamerContext = initialContext.Streamer;
      streamerContext.clientNodeId = window.LivingScript_0070.guid.generateSync();
      streamerContext.componentId = streamerContext.clientNodeId;
      streamerContext.HistoryID = window.LivingScript_0070.guid.generateSync();
      window.botStore.addContext(streamerContext);
      setTimeout(() => {
        let CallPE = null;
        let InitialContext = {Caller:{Audio:false,NoShow:true,Screen:false,Video:true},Callee:{Audio:false,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
        let callObj = {Mode:"STARTMEDIA" ,ClientID:streamerContext.clientNodeId,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
        window.BotServices.startCall(callObj);
      }, 3000);
    }
  }

  //console.log("Is refresh State : ", refreshContexts, window.LivingScript_0070.context.attribution);
  if(refreshContexts == null && window.LivingScript_0070.context.attribution && window.LivingScript_0070.context.attribution.length > 0) {
    window.botStore.setAttributions(window.LivingScript_0070.context.attribution);
    //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
    //addMeetingMenu(primaryAccount, () => {});

    let params = {
      contextPE : window.LivingScript_0070.context.contextPE,
      canonicalPE : window.LivingScript_0070.context.contextPE,
      clientNodeId : window.LivingScript_0070.guid.generateSync(),
      primaryAccount : window.botStore.getAccountByType('PrimaryAccount')
    }
    getClientContext(params, (err, context) => {
      //console.log("Client Context Result =>  ", context);
      let contextObj = JSON.parse(context);
      //console.log("contextObj : ", contextObj.Result.FullGrantPath);
      if(contextObj.Result && contextObj.Result.FullGrantPath && contextObj.Result.FullGrantPath.PEPath) {
        let account = window.botStore.getAccountByGatewayPE(contextObj.Result.FullGrantPath.PEPath[1]);
        if(account) {
          contextObj.Result.AttributionID = account.ID;
          contextObj.Result.Account = account; 
        } else {
          account = window.botStore.getAccountByType('PrimaryAccount');
          contextObj.Result.AttributionID = account.ID;
          contextObj.Result.Account = account;
        }
        contextObj.Result.IsLanding = false;
        contextObj.Result.browserTabId = window.LivingScript_0070.context.browserTabId;
        contextObj.Result.credentialPE = account.CredentialPE;
        contextObj.Result.GatewayPE = contextObj.Result.FullGrantPath.PEPath[1];
        contextObj.Result.GatewayGrantId = contextObj.Result.FullGrantPath.GrantPath[1];
        contextObj.Result.AgentOfPE = account.AgentOfPE;
        contextObj.Result.FromGrantID = contextObj.Result.grantItem.FromGrantID;
        contextObj.Result.FromPE = contextObj.Result.grantItem.FromPE;
        contextObj.Result.ByGrantID = contextObj.Result.grantItem.ByGrantID;
        contextObj.Result.ByPE = contextObj.Result.grantItem.ByPE;
        contextObj.Result.HistoryID = window.LivingScript_0070.guid.generateSync();
        window.botStore.addContext(contextObj.Result);
      }
    });
  }
});

function SyncLoading() {
  //console.log("SyncLoading : ", appSync, appSync.length);
  if(appSync.length == 3) {
    if(window.LivingScript_0070 && window.LivingScript_0070.propagatorInit) {
      window.BotServices.clientManagerInit(config);
      window.BotServices.callManagerInit(config);
      const DeviceMgrWidgetLoaded = new Event('DeviceMgrWidgetLoaded');
      window.dispatchEvent(DeviceMgrWidgetLoaded);
    } else {
      window.addEventListener('propagatorInit', (e) => {
          window.BotServices.clientManagerInit(config);
          window.BotServices.callManagerInit(config);
          const DeviceMgrWidgetLoaded = new Event('DeviceMgrWidgetLoaded');
          window.dispatchEvent(DeviceMgrWidgetLoaded);
      })
    }
    
    if(refreshContexts && refreshContexts.length > 0) {
      window.LivingScript_0070.context.clientNodeId = refreshContexts[0].clientNodeId;
      window.LivingScript_0070.context.componentId = refreshContexts[0].clientNodeId;
      window.LivingScript_0070.context.IsLanding = true;

      if(defDeskContext && defDeskContext.DeskID) {
        refreshContexts[0].DeskID = defDeskContext.DeskID;
      }
      //console.log("Refresh Page Context");
      refreshContexts.forEach((context) => {
        context.IsRefresh = true;
        context.HistoryID = window.LivingScript_0070.guid.generateSync();
        window.botStore.addContext(context);
      });
    } else {
     //console.log("FirstLoad Page Context");
     //window.botStore.addContext(window.LivingScript_0070.context);
     window.LivingScript_0070.context.clientNodeId = (window.LivingScript_0070.context.clientNodeId) ? window.LivingScript_0070.context.clientNodeId : window.LivingScript_0070.guid.generateSync();
     window.LivingScript_0070.context.componentId = window.LivingScript_0070.context.clientNodeId;
     window.LivingScript_0070.context.IsLanding = true;
     window.LivingScript_0070.context.MeetingContext = {
       MeetingRootId : window.LivingScript_0070.context.browserTabId,
       MeetingParentId : (defMeetingContext && defMeetingContext.MeetingParentId) ? defMeetingContext.MeetingParentId : window.LivingScript_0070.context.browserTabId,
       MeetingParentRole: (defMeetingContext) ? 'Participant' : 'Moderator',
       MeetingRole: (defMeetingContext) ? 'Participant' : 'Moderator',
       MeetingId: (defMeetingContext && defMeetingContext.MeetingId) ? defMeetingContext.MeetingId : window.LivingScript_0070.context.browserTabId,
       MeetingPE: (defMeetingContext && defMeetingContext.MeetingParentId && defMeetingContext.MeetingId) ? window.LivingScript_0070.oes.encodeStringsSync(['Participant', defMeetingContext.MeetingParentId, 'Participant', defMeetingContext.MeetingId]) : window.LivingScript_0070.oes.encodeStringsSync(['Moderator', window.LivingScript_0070.context.browserTabId, 'Moderator', window.LivingScript_0070.context.browserTabId]),
       ServerID : (defMeetingContext && defMeetingContext.ServerID) ? defMeetingContext.ServerID : window.botStore.serverinfo.Node,
       ServerDN : (defMeetingContext && defMeetingContext.ServerDN) ? defMeetingContext.ServerDN : window.botStore.serverinfo.DisplayName
     }
     //console.log("defDeskContext Landing Page : ", defDeskContext);
     if(defDeskContext && defDeskContext.DeskID) {
        window.LivingScript_0070.context.DeskID = defDeskContext.DeskID;
     }
     //console.log("GetClientContext : ", JSON.stringify(oxygen.context));
     let landingContext = JSON.parse(JSON.stringify(window.LivingScript_0070.context));
     landingContext.HistoryID = window.LivingScript_0070.guid.generateSync();
     window.botStore.addContext(landingContext);        
   }
   /* Start a session Pinger to check heath of the Live session */
   //sessionHealth();
    const ContextLoaded = new Event('LandingContextLoaded');
    window.dispatchEvent(ContextLoaded);
    watchRootMenu();
  }
}

function sessionHealth() {
  const myInterval = setInterval(() =>{
    httpRequest({
      method : 'GET',
      type : "application/json",
      url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/sessionPing',
      data : {BrowserTabID : window.LivingScript_0070.context.browserTabId, SessionID : window.LivingScript_0070.context.sessionId}
    }, (err, result) => {
      if(err) {
        console.log("SessionState Error : ", err);
      } else {
        if(isJSON(result)) {
          let status = JSON.parse(result);
          if(status.SessionState && status.SessionState == 'Error') {
            //clearInterval(myInterval);
            //alert(status.SessionState, " : ", status.Reason, ", Please Refresh To Continue!");
            //window.location.reload();
          }
        } else {
            //console.log("SessionState : ", "Session Lost");
            clearInterval(myInterval);
            alert("Error : Session Lost, Please Refresh To Continue!");
            window.location.reload();
        }
      }
    });
  }, 3000 * 60);
}

function isJSON(str) {
  try {
      return (JSON.parse(str) && !!str);
  } catch (e) {
      return false;
  }
}

window.addEventListener('botServicesLoaded', (e) => {
  appSync.push("BotServices");
  SyncLoading();
});

window.addEventListener('devMgrLoaded', (e) => {
  appSync.push("DevStore");
  SyncLoading();
});

window.addEventListener('commAppLoad', (e) => {
   appSync.push('CommApp');
   SyncLoading();
});


// if(window.LivingScript_0070 && window.LivingScript_0070.propagatorInit) {
//   window.BotServices.clientManagerInit(config);
// } else {
//   window.addEventListener('propagatorInit', (e) => {
//       window.BotServices.clientManagerInit(config);
//       window.BotServices.callManagerInit
//   })
// }
// window.addEventListener('DOMContentLoaded', function() {
  
//   // Update the URL in the address bar without reloading
//   // history.pushState({}, "", "/pretty.com?" + window.location.search);

//   // // Update the document title (optional)
//   // document.title = "Pretty Title";
// });

window.addEventListener('touchend', function(event) {
  if(window.CommApp) {
	   window.CommApp.interaction(event);
   }
});

window.addEventListener("click", function(event) {
  if(window.CommApp) {
	   window.CommApp.interaction(event);
   }
});

window.addEventListener("userSignedIn", (event) => {
    console.log("userSignedIn : ", event);
    let Attributions = event.detail.user.Attribution;
    window.botStore.setAttributions(Attributions);
    //let primaryAccount = window.botStore.getAccountByType('PrimaryAccount');
    //addMeetingMenu(primaryAccount, () => {});    
    /*
    let Attribution = event.detail.user.Attribution;
    if(Attribution && Attribution.length > 0) {
      Attribution.forEach((accountItem) => {
        if(accountItem.AccountType == 'PrimaryAccount') {
          let primaryAccount = JSON.parse(JSON.stringify(accountItem));
          let params = {
            contextPE : primaryAccount.CredentialPE,
            canonicalPE : primaryAccount.GatewayPE,
            clientNodeId : window.LivingScript_0070.guid.generateSync()
          }
          getClientContext(params, (err, context) => {
            console.log("Client Context Result =>  ", context);
            let contextObj = JSON.parse(context);
            contextObj.Result.IsLanding = false;
            window.botStore.addContext(contextObj.Result);
          })
        }
      });
    }*/
});

window.addEventListener("userAuthenticated", (event) => {
  console.log("Got userAuthenticated : ");
  let OpenPE = null;
  let GatewayPE = null;
  let initialContext = window.LivingScript_0070.context.urlContext;
  console.log("onLogin : ", window.LivingScript_0070.context.urlContext);
  if(window.LivingScript_0070.context.onLoadaction && window.LivingScript_0070.context.onLoadaction.signup && window.LivingScript_0070.context.onLoadaction.role && window.LivingScript_0070.context.onLoadaction.component) {
    //let account = window.botStore.getAccountByType('PersonalAccount');
    let account = window.botStore.getAccountByType('PrimaryAccount');
    if(account) {
      GatewayPE = account.GatewayPE;
      OpenPE = window.LivingScript_0070.oes.encodeStringsSync([account.GatewayRightR, account.GatewayRightID, window.LivingScript_0070.context.onLoadaction.role, window.LivingScript_0070.context.onLoadaction.component]);
    }
  } else if(window.LivingScript_0070.context.urlContext && window.LivingScript_0070.context.urlContext.onLogin && window.LivingScript_0070.context.urlContext.onLogin.length > 0) {
    window.LivingScript_0070.context.urlContext.onLogin.forEach((rule) => {
      if(rule.open && rule.component && rule.role) {
        let account = window.botStore.getAccountByType('PrimaryAccount');
        if(account) {
          GatewayPE = account.GatewayPE;
          OpenPE = window.LivingScript_0070.oes.encodeStringsSync([account.GatewayRightR, account.GatewayRightID, rule.role, rule.component]);
          console.log("OpenPE onLogin : ", OpenPE);
          if(rule.child) {
            initialContext = {ChildPanel : rule.child};
          }
        }
      }
    });
  }
  /*
  let loggedInContext = JSON.parse(JSON.stringify(window.LivingScript_0070.context));
  loggedInContext.clientNodeId = window.LivingScript_0070.guid.generateSync();
  loggedInContext.componentId = loggedInContext.clientNodeId;
  let meetingId = window.LivingScript_0070.guid.generateSync();
  loggedInContext.MeetingContext = {
    MeetingRootId : meetingId,
    MeetingParentId : meetingId,
    MeetingParentRole: 'Moderator',
    MeetingParentId: meetingId,
    MeetingRole: 'Moderator',
    MeetingId: meetingId,
    MeetingPE: window.LivingScript_0070.oes.encodeStringsSync(['Moderator', meetingId, 'Moderator', meetingId])
  }
  window.botStore.addContext(loggedInContext);
  */
  let params = {
    contextPE : (GatewayPE) ?  GatewayPE :  window.LivingScript_0070.context.contextPE,
    canonicalPE : (OpenPE) ?  OpenPE :  window.LivingScript_0070.context.contextPE,
    clientNodeId : window.LivingScript_0070.guid.generateSync(),
    primaryAccount : window.botStore.getAccountByType('PrimaryAccount')
  }
  getClientContext(params, (err, context) => {
    //console.log("Client Context Result =>  ", context);
    let contextObj = JSON.parse(context);
    //console.log("contextObj : ", contextObj.Result.FullGrantPath);
    if(contextObj.Result && contextObj.Result.FullGrantPath && contextObj.Result.FullGrantPath.PEPath) {
      let account = window.botStore.getAccountByGatewayPE(contextObj.Result.FullGrantPath.PEPath[1]);
      if(account) {
        contextObj.Result.AttributionID = account.ID;
        contextObj.Result.Account = account; 
      } else {
        account = window.botStore.getAccountByType('PrimaryAccount');
        contextObj.Result.AttributionID = account.ID;
        contextObj.Result.Account = account;
      }
      contextObj.Result.IsLanding = false;
      contextObj.Result.browserTabId = window.LivingScript_0070.context.browserTabId;
      contextObj.Result.credentialPE = account.CredentialPE;
      contextObj.Result.GatewayPE = contextObj.Result.FullGrantPath.PEPath[1];
      contextObj.Result.GatewayGrantId = contextObj.Result.FullGrantPath.GrantPath[1];
      contextObj.Result.AgentOfPE = account.AgentOfPE;
      contextObj.Result.FromGrantID = contextObj.Result.grantItem.FromGrantID;
      contextObj.Result.FromPE = contextObj.Result.grantItem.FromPE;
      contextObj.Result.ByGrantID = contextObj.Result.grantItem.ByGrantID;
      contextObj.Result.ByPE = contextObj.Result.grantItem.ByPE;
      contextObj.Result.InitialContext = initialContext;
      contextObj.Result.HistoryID = window.LivingScript_0070.guid.generateSync();
      window.botStore.addContext(contextObj.Result);
    }
  });
});

function credentialConnect() {
  //console.log("Connect : ", window.LivingScript_0070.context.credentialId);
  const rootMenu = ydoc.getArray(window.LivingScript_0070.context.credentialId);
  rootMenu.observe(event => {
    //console.log('RootMenu : ', rootMenu.get(0));
  })
  rootMenu.push([{"Hello" : "There"}]);
}

function sessionRequest(callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/start',
    data : { sessionId : window.LivingScript_0070.context.sessionId, browserTabId : window.LivingScript_0070.context.browserTabId }
  }, callback);
}

function getClientContext(params, callback) {
  httpRequest({
    method : 'GET',
    type : "application/json",
    url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getClientContext',
    data : {
      contextPE : params.contextPE,
      clientPE : params.canonicalPE,
      clientNodeId : params.clientNodeId,
      primaryAccount : (params.primaryAccount) ? params.primaryAccount : null,
      meetingContext : (params.meetingContext) ? params.meetingContext : null
    }
  }, callback);
}

function getHistory(params, callback) {
  httpRequest({
    method : 'GET',
    type : "application/json",
    url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getHistory',
    data : params
  }, callback);
}

function openClientContext (params, callback) {
  console.log("openClientContext got : ", params);
  if(params.ByClientID) {
    let Client = window.botStore.getClientByID(params.ByClientID);
    let CurrentContext = JSON.parse(Client.CurrentContext);
    let currentAccount = CurrentContext.Account;
    //console.log("openClientContext By  : ", CurrentContext);
    let paccount = window.botStore.getAccountByType('PrimaryAccount');
    let contextReq = {
      //contextPE : (paccount) ? paccount.GatewayPE : window.LivingScript_0070.context.contextPE,
      contextPE : (currentAccount) ? currentAccount.GatewayPE : (paccount) ? paccount.GatewayPE : window.LivingScript_0070.context.contextPE,
      canonicalPE : params.OpenPE,
      clientNodeId : window.LivingScript_0070.guid.generateSync(),
      primaryAccount : window.botStore.getAccountByType('PrimaryAccount'),
      meetingContext : (params.MeetingContext) ? params.MeetingContext : null
    }

    getClientContext(contextReq, (err, context) => {
      //console.log("Attachment Client Context Result =>  ", context);
      let clientContext = initContex(context, params.InitialContext);
      //console.log("Test New Accout fetch function : ", getCurrentAccount(clientContext.FullGrantPath.PEPath));
      if(clientContext) {
        //let account = window.botStore.getAccountByGatewayPE(clientContext.FullGrantPath.PEPath[1]);
        let accountInfo = getCurrentAccount(clientContext.FullGrantPath.PEPath);
        let account = accountInfo?.account;
        if(account) {
          //console.log("Resolved the account to open PE");
          clientContext.IsLanding = false;
          clientContext.browserTabId = window.LivingScript_0070.context.browserTabId;
          clientContext.credentialPE = account.CredentialPE;
          clientContext.GatewayPE = clientContext.FullGrantPath.PEPath[accountInfo.position];
          clientContext.GatewayGrantId = clientContext.FullGrantPath.GrantPath[accountInfo.position];
          clientContext.AgentOfPE = account.AgentOfPE;
          clientContext.FromGrantID = clientContext.grantItem.FromGrantID;
          clientContext.FromPE = clientContext.grantItem.FromPE;
          clientContext.ByGrantID = clientContext.grantItem.ByGrantID;
          clientContext.ByPE = clientContext.grantItem.ByPE;
          clientContext.AttributionID = account.ID;
          clientContext.Account = account;
          //clientContext.InitialContext = params.InitialContext;
          clientContext.DeskID = (params.DeskID) ? params.DeskID : null;
          clientContext.HistoryID = window.LivingScript_0070.guid.generateSync();
          window.botStore.addContext(clientContext);
          if(callback) {
            callback(null, clientContext);
          }
        } else {
          //console.log("Not Resolved account to open, use primary account");
          account = window.botStore.getAccountByType('PrimaryAccount');
          clientContext.IsLanding = false;
          clientContext.browserTabId = window.LivingScript_0070.context.browserTabId;
          clientContext.credentialPE = (account) ? account.CredentialPE : window.LivingScript_0070.context.GatewayPE;
          clientContext.GatewayPE = clientContext.FullGrantPath.PEPath[1];
          clientContext.GatewayGrantId = clientContext.FullGrantPath.GrantPath[1];
          clientContext.AgentOfPE = (account) ? account.AgentOfPE : window.LivingScript_0070.context.AgentOfPE;
          clientContext.FromGrantID = clientContext.grantItem.FromGrantID;
          clientContext.FromPE = clientContext.grantItem.FromPE;
          clientContext.ByGrantID = clientContext.grantItem.ByGrantID;
          clientContext.ByPE = clientContext.grantItem.ByPE;
          clientContext.AttributionID = (account) ? account.ID : null;
          clientContext.Account = (account) ? account : null;
          //clientContext.InitialContext = params.InitialContext;
          clientContext.DeskID = (params.DeskID) ? params.DeskID : null;
          clientContext.HistoryID = window.LivingScript_0070.guid.generateSync();
          window.botStore.addContext(clientContext);
          if(callback) {
            callback(err, clientContext);
          }
        }        
      } else {
        if(callback) {
          callback(err, null);
        }
      }
    });
  }
}

function getCurrentAccount(grantPath) {
  if (grantPath && grantPath.length > 0) {
    for (let i = grantPath.length - 1; i >= 0; i--) {
      let account = window.botStore.getAccountByGatewayPE(grantPath[i]);
      if (account) {
        return { account, position: i }; // Return both account and position
      }
    }
  } else {
    let account = window.botStore.getAccountByType('PrimaryAccount');
    return { account, position: 1 }; // No position in this case
  }
}

function initContex(context, initailContext) {
  let contextObj = JSON.parse(context);
  //console.log("initContex : ", contextObj, initailContext);
  if(contextObj.Result && contextObj.Result.FullGrantPath && contextObj.Result.FullGrantPath.PEPath) {
    let currentContext = contextObj.Result;
    currentContext.InitialContext = (initailContext) ? initailContext : null;
    currentContext.MeetingContext = initMeetingContext(currentContext.MeetingContext, initailContext);
    return currentContext;
  } else {
    return null;
  }
}

function initMeetingContext(meetingContext, initailContext) {
  if(meetingContext && initailContext && initailContext.JoinMeetingContext) {
    meetingContext.MeetingParentId = initailContext.JoinMeetingContext.MeetingParentId;
    meetingContext.MeetingParentDN = initailContext.JoinMeetingContext.MeetingParentDN;
    meetingContext.MeetingId = initailContext.JoinMeetingContext.MeetingId;
    meetingContext.MeetingDN = initailContext.JoinMeetingContext.MeetingDN;
    meetingContext.MeetingParentRole = 'Participant';
    meetingContext.MeetingRole = 'Participant';
    meetingContext.ServerID = initailContext.JoinMeetingContext.ServerID;
    meetingContext.ServerDN = initailContext.JoinMeetingContext.ServerDN;
    meetingContext.serverConfig = initailContext.JoinMeetingContext.serverConfig;
    meetingContext.serverInfo = initailContext.JoinMeetingContext.serverInfo;
    meetingContext.MeetingPE = window.LivingScript_0070.oes.encodeStringsSync(['Participant', meetingContext.MeetingParentId, 'Participant', meetingContext.MeetingId]);
  }
  console.log("initMeetingContext : ", meetingContext);
  return meetingContext;
}

function closeClientContext(params, callback) {
  //console.log("closeClientContext Got : ", params);
  if(params && params.ClientRowID) {
    if(params.Type == 'Parent') {
      if(params.PermanentLink) {
        //window.devStore.updateRootMenu({Reset : true, Path : params.Path});
      } else {
        
      }
      window.botStore.delContext(params.ClientRowID);
    }
  }
}

function openChildPanel(params, callback) {
  //console.log("openChildPanle got : ", params);
  if(params.ClientID && params.DisplayName && params.Termination) {
    let client = window.botStore.getClientByID(params.ClientID);
    let meetingObj = JSON.parse(client.MeetingContext);
    let parentIndex = window.devStore.getMeetingIndex(meetingObj.MeetingRootId);
    let localIndex = window.devStore.getMeetingIndex(meetingObj.MeetingParentId);
    let currentContext = JSON.parse(client.CurrentContext);

    let menuObj = {
      ParentIndex : parentIndex,
      LocalIndex : localIndex,
      MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : meetingObj.MeetingRootId,
      MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : meetingObj.MeetingParentId,
      PrettyURL : null,
      //Path : client.RootMeeting + '/' + params.DisplayName,
      Path : meetingObj.MeetingRootId + '/' + meetingObj.MeetingParentId + '/' + params.DisplayName,
      LeftRole : client.ClientLeftRole,
      RightRole : client.ClientRightRole,
      LeftID : client.ClientLeft,
      RightID : client.ClientRight,
      LeftDN : currentContext.grantItem.GrantLeftDN,
      RightDN : currentContext.grantItem.GrantRightDN + '/' + params.DisplayName,
      DisplayStatus : null,
      ClientRowID : client.Client,
      Termination : params.Termination,
      PermanentLink : false,
      InitialContext : (params.InitialContext) ? params.InitialContext : null,
      Type : 'Child',
      TopLeftX: params.TopLeftX || 0,
      TopRightY: params.TopRightY || 0
    };

    window.devStore.addRootMenu(menuObj);
    window.BotServices.PullRootMenu(menuObj, callback);
  }
}

function getGrant(params, callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getGrant',
    data : {
      context : params.context,
      grantPE : params.grantPE,
      toPE : params.toPE
    }
  }, callback);
}

function getContacts(params, callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getContacts',
    data : params
  }, callback);
}

function getMeetings(params, callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getMeetings',
    data : params
  }, callback);
}

function addRootMenu(data, callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/addmenu',
    data : data
  }, callback);
}

function addMeetingMenu(params, callback) {
  getMeetings(params, (err, result) => {
    //console.log("Get Meetings result : ", result);
    let data = JSON.parse(result);
    if(data && data.Result && data.Result.length > 0) { 
      let meetings =  data.Result;
      meetings.forEach((item) => {
        let argJson = JSON.parse(item.ArgJSON);
        let meetingObj = argJson.MeetingContext;
        let grantItem = argJson.GrantItem;

        //console.log("Add meeting menu  currentContext : ", currentContext);

        if(meetingObj && grantItem) {
          window.devStore.addMeetingIndex(meetingObj.MeetingRootId);
          window.devStore.addMeetingIndex(meetingObj.MeetingParentId);
        
          let parentIndex = window.devStore.getMeetingIndex(meetingObj.MeetingRootId);
          let localIndex = window.devStore.getMeetingIndex(meetingObj.MeetingParentId);

          let menuObj = {
            ParentIndex : parentIndex,
            LocalIndex : localIndex,
            MeetingRootDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingRootDN,
            MeetingParentDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingParentDN,
            MeetingRootID : meetingObj.MeetingRootId,
            MeetingParentID : meetingObj.MeetingParentId,
            MeetingRole : meetingObj.MeetingParentRole,
            PrettyURL : null,
            Path : meetingObj.MeetingRootId + '/' + meetingObj.MeetingParentId,
            LeftRole : grantItem.GrantLeftR,
            RightRole : grantItem.GrantRightR,
            LeftID : grantItem.GrantLeftID,
            RightID : grantItem.GrantRightID,
            LeftDN : grantItem.GrantLeftDN,
            RightDN : grantItem.GrantRightDN,
            DisplayStatus : null,
            ClientRowID : null,
            PermanentLink : true,
            MeetingContext : meetingObj,
            Type : 'Parent'
          };

          window.devStore.addRootMenu(menuObj);
        }
      });
    }
  })
}

function openMenuItem(data, callback) {
  console.log("openMenuItem data : ", data, "ViewportID : ", data.ViewPortID);
  //let initailContext = data.InitialContext;
  let panelType = (data && data.Type && data.Type == 'Child') ? "Child" : "Parent"; 
  if(data && data.ClientRowID) {
    if(data.ViewPortID) {
      displayPanels(data.ViewPortID);
      callback(null, {ClientRowID : data.ClientRowID, ViewPortID : data.ViewPortID});
    } else {
      displayPanels(null);
      let Client = window.botStore.getClientByID(data.ClientRowID);
      if(Client) {
        httpRequest({
          method : 'POST',
          type : "application/json",
          url : sessionUrl + '/getmenu',
          data : data
        }, (err, result) => {
          console.log("getMenuContext : ", result);
          let menuInfo = JSON.parse(result);
          let ClientRowID = null;
          if(menuInfo) {
            let Context = JSON.parse(Client.CurrentContext);
            let InitialContext = JSON.parse(Client.InitialContext);
            Context.Path = data.Path;
            ClientRowID = data.ClientRowID;           
            
            let viewPortId = window.LivingScript_0070.guid.generateSync();
            let mobile = isMobile();
            let width = (InitialContext && InitialContext.viewPort && InitialContext.viewPort.width) ? InitialContext.viewPort.width : '415px';
            if(window.botStore.settings && window.botStore.settings.Display == 'FullScreen') {
              width = '100%';
            }

            //Opening child panel, by default, on top of its parent, unless its specific values are specified
            let TopLeftX = data.TopLeftX || "0", TopRightY = data.TopRightY || "0";
            if(panelType === 'Child') {
              let parentRootMenuItem = window.devStore.rootMenu.find(e => (e.ClientRowID === Context.clientNodeId) && (e.Type == 'Parent')), viewportElem;
              if(parentRootMenuItem && (viewportElem = window.top.document.getElementById(parentRootMenuItem.ViewPortID))) {
                TopLeftX = parseInt(viewportElem.style.left);
                TopRightY = parseInt(viewportElem.style.top);
              }
            }

            let viewport = {
              viewportID : viewPortId,
              ClientID : Context.clientNodeId,
              MeetingPath : '/',
              ClientPath : data.Path,
              TopLeftX,
              TopRightY,
              ZIndex : 1000,
              Width: (mobile) ? "100%" : width,
              Height : 'auto',
              PanelTitle: data.ParentIndex + "/" + data.LocalIndex +" " + menuInfo.asComponent.DisplayName + '/' + menuInfo.atComponent.DisplayName,
              DisplayState : '',
              isLanding : false,
              LocalState : 'Show'
            }
            window.BotServices.PullViewPort(viewport, data);
            //if(Context.AttributionID || Context.grantItem.GrantRightR == 'visitor') {
            //console.log("OpenTermiation : ", panelType, menuInfo.atComponent);
            
            //console.log("DeskContext Termination Start: ", Context.clientNodeId);
            if(panelType == 'Parent' && Client.DeskContext) {
              let deskContext = JSON.parse(Client.DeskContext);
              //console.log("DeskContext Termination Do : ", Context.clientNodeId, JSON.stringify(deskContext));
              if(deskContext.Node && deskContext.Component) {
                //console.log("DeskContext Termination Add : ", deskContext.Node.Condition, deskContext.Component.InitialContext);
                if(deskContext.Node.Condition == 'Active' && deskContext.Component.InitialContext && deskContext.Component.InitialContext.Termination) {
                  data.Termination = JSON.parse(JSON.stringify(deskContext.Component.InitialContext.Termination));
                }
              }
            }

            if(panelType == 'Parent' && menuInfo.atComponent && menuInfo.atComponent.MetaType == 'Template') {
              if(menuInfo.atComponent.InitialContext.TemplateTermination) {
                let terminationConfig = menuInfo.atComponent.InitialContext.TemplateTermination;
                (terminationConfig.dataset) ? terminationConfig.dataset.clientid = Context.clientNodeId : terminationConfig.dataset = {clientid : Context.clientNodeId};
                let termination = {
                  viewportID : viewPortId,
                  terminationID : window.LivingScript_0070.guid.generateSync(),
                  MediaType : terminationConfig.MediaType,
                  URL : terminationConfig.URL,
                  CssLink : terminationConfig.CssLink,
                  Elements : (terminationConfig.Elements) ? terminationConfig.Elements : null,
                  Template : terminationConfig.Template,
                  dataset : terminationConfig.dataset
                }
                //console.log("PullTermination Template : ", JSON.stringify(termination));
                window.BotServices.PullTermination(termination, data);
              } else {
                let termination = {
                  viewportID : viewPortId,
                  terminationID : window.LivingScript_0070.guid.generateSync(),
                  MediaType : 'WebComponent',
                  URL : '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/template-form-wc/dist/js/app.js',
                  CssLink : null,
                  Template : 'template-form',
                  dataset : {clientid : Context.clientNodeId}
                }

                if(data.Termination) {
                  termination = data.Termination;
                }
                //console.log("PullTermination Def: ", termination);
                window.BotServices.PullTermination(termination, data);
              }
            } else {
              //console.log("DeskContext Termination Tip : ", Context.clientNodeId, data.Termination);
              if(menuInfo.atComponent && menuInfo.atComponent.InitialContext && ( menuInfo.atComponent.InitialContext.Termination || data.Termination)) {
                let terminationConfig = data.Termination || menuInfo.atComponent.InitialContext.Termination;
                (terminationConfig.dataset) ? terminationConfig.dataset.clientid = Context.clientNodeId : terminationConfig.dataset = {clientid : Context.clientNodeId};
                let termination = {
                  viewportID : viewPortId,
                  terminationID : window.LivingScript_0070.guid.generateSync(),
                  MediaType : terminationConfig.MediaType,
                  URL : terminationConfig.URL,
                  CssLink : terminationConfig.CssLink,
                  Elements : (terminationConfig.Elements) ? terminationConfig.Elements : null,
                  Template : terminationConfig.Template,
                  dataset : terminationConfig.dataset
                }
                //console.log("PullTermination : ", termination);
                window.BotServices.PullTermination(termination, data);
              } else if(data.Termination) {
                let termination = data.Termination;
                //console.log("PullTermination : ", termination);
                window.BotServices.PullTermination(termination, data);
              }
            }
            //}
            callback(null, {ClientRowID : ClientRowID, ViewPortID : viewPortId});
            console.log("InitialContext On Open : ", InitialContext, panelType);
            if(panelType == 'Parent' && InitialContext && InitialContext.ChildPanel) {
              console.log("Open Child Panel Got : ", InitialContext.ChildPanel, panelType);
              openChildPanel({ClientID : ClientRowID, DisplayName : InitialContext.ChildPanel.DisplayName, Termination : InitialContext.ChildPanel.Termination}, () => {});
            }
          } else {
            callback("No Context Info", null);
          }
        });
      } else {
        callback("No Client Found for ClietID " + data.ClientRowID, null);
      }
    }
  } else {
    if(data.LeftRole && data.LeftID && data.RightRole && data.RightID) {
      let params = {
        ByClientID : window.botStore.clients[0].Client,
        OpenPE : window.LivingScript_0070.oes.encodeStringsSync([data.LeftRole, data.LeftID, data.RightRole, data.RightID]),
        MeetingContext : data.MeetingContext || null,
      }
      openClientContext(params, callback);
    } else {
      console.log("No hope to open this link!");
      callback("Bad Link", {});
    }
  }


  // if(data && data.ClientRowID && data.ViewPortID) {
  //   console.log("Panel already exist, display only");
  //   displayPanels(data.ViewPortID);
  //   callback(null, {ClientRowID : data.ClientRowID, ViewPortID : data.ViewPortID});
  // } else {
  //   displayPanels(null);
  //   httpRequest({
  //     method : 'POST',
  //     type : "application/json",
  //     url : sessionUrl + '/getmenu',
  //     data : data
  //   }, (err, result) => {
  //     console.log("getMenuContext : ", result);
  //     let menuInfo = JSON.parse(result);
  //     let ClientRowID = null;
  //     if(menuInfo) {
  //       let Context = JSON.parse(JSON.stringify(window.LivingScript_0070.context));
  //       let InitialContext = {};
  //       if(data && data.ClientRowID) {
  //         let Client = window.botStore.getClientByID(data.ClientRowID);
  //         Context = JSON.parse(Client.CurrentContext);
  //         InitialContext = JSON.parse(Client.InitialContext);
  //         Context.clientNodeId = data.ClientRowID;
  //         Context.Path = data.Path;
  //         console.log("Client Already Exist, no need to PullClient");
  //         ClientRowID = data.ClientRowID;
  //       } else {
  //         // Context.clientNodeId = window.LivingScript_0070.guid.generateSync();
  //         // Context.IsLanding = false;
  //         // Context.Path = data.Path;
  //         // Context.MeetingContext = {
  //         //   MeetingRootId : window.LivingScript_0070.context.browserTabId,
  //         //   MeetingParentId : window.LivingScript_0070.context.browserTabId,
  //         //   MeetingParentRole: 'Moderator',
  //         //   MeetingParentId: window.LivingScript_0070.context.browserTabId,
  //         //   MeetingRole: 'Moderator',
  //         //   MeetingId: window.LivingScript_0070.context.browserTabId,
  //         //   MeetingPE: window.LivingScript_0070.oes.encodeStringsSync(['Moderator', window.LivingScript_0070.context.browserTabId, 'Moderator', window.LivingScript_0070.context.browserTabId])
  //         // }
  //         // window.BotServices.PullClient(Context, data);
  //         // ClientRowID = Context.clientNodeId;
  //       }

  //       let viewPortId = window.LivingScript_0070.guid.generateSync();
  //       let mobile = isMobile();
  //       let width = (InitialContext && InitialContext.viewPort && InitialContext.viewPort.width) ? InitialContext.viewPort.width : '415px';
  //       let viewport = {
  //         viewportID : viewPortId,
  //         ClientID : Context.clientNodeId,
  //         MeetingPath : '/',
  //         ClientPath : Context.clientNodeId+'/',
  //         TopLeftX : "0",
  //         TopRightY : "0",
  //         ZIndex : 1000,
  //         Width: (mobile) ? "100%" : width,
  //         Height : 'auto',
  //         PanelTitle: data.ParentIndex + "/" + data.LocalIndex +" " + menuInfo.asComponent.DisplayName + '/' + menuInfo.atComponent.DisplayName,
  //         DisplayState : '',
  //         isLanding : false
  //       }
  //       window.BotServices.PullViewPort(viewport, data);
  //       //if(Context.AttributionID || Context.grantItem.GrantRightR == 'visitor') {
  //         console.log("OpenTermiation : ", menuInfo.atComponent);
  //         if(Context.atComponent && Context.atComponent.MetaType == 'Template') {
  //           if(menuInfo.atComponent.InitialContext.TemplateTermination) {
  //             let terminationConfig = menuInfo.atComponent.InitialContext.TemplateTermination;
  //             let termination = {
  //               viewportID : viewPortId,
  //               terminationID : window.LivingScript_0070.guid.generateSync(),
  //               MediaType : terminationConfig.MediaType,
  //               URL : terminationConfig.URL,
  //               CssLink : terminationConfig.CssLink,
  //               Template : terminationConfig.Template,
  //               dataset : {clientid : Context.clientNodeId}
  //             }
  //             window.BotServices.PullTermination(termination, data);
  //           } else {
  //             let termination = {
  //               viewportID : viewPortId,
  //               terminationID : window.LivingScript_0070.guid.generateSync(),
  //               MediaType : 'WebComponent',
  //               URL : '/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/template-form-wc/dist/js/app.js',
  //               CssLink : null,
  //               Template : 'template-form',
  //               dataset : {clientid : Context.clientNodeId}
  //             }
  //             window.BotServices.PullTermination(termination, data);
  //           }
  //         } else {
  //           if(menuInfo.atComponent && menuInfo.atComponent.InitialContext && ( menuInfo.atComponent.InitialContext.Termination || data.Termination)) {
  //             let terminationConfig = data.Termination || menuInfo.atComponent.InitialContext.Termination;
  //             let termination = {
  //               viewportID : viewPortId,
  //               terminationID : window.LivingScript_0070.guid.generateSync(),
  //               MediaType : terminationConfig.MediaType,
  //               URL : terminationConfig.URL,
  //               CssLink : terminationConfig.CssLink,
  //               Template : terminationConfig.Template,
  //               dataset : {clientid : Context.clientNodeId}
  //             }
  //             window.BotServices.PullTermination(termination, data);
  //           }
  //         }
  //       //}
  //       callback(null, {ClientRowID : ClientRowID, ViewPortID : viewPortId});
  //     } else {
  //       callback("No Context Info", null);
  //     }
  //   });
  // }
}

function watchRootMenu() {
  window.BotServices.Events.subscribe({
    next : ((event) => {
        if(event.RootMenu) {
          if(windowMode) {
            event.RootMenu.forEach((menu) => {
              if(menu.RightDN == 'SimpliaHome') {
                window.BotServices.PullRootMenu(menu, (err, result) => {
                  //console.log("Pull Landing RootMenu : ", result);
                });
              }
            });
          }
          //console.log("Session Watch RootMenu Event : ", event);
        }
    }),
  });
}

function displayPanels(ViewPortID) {
  /*
  let viewPorts = window.devStore.viewPorts;
  if(ViewPortID) {
    viewPorts.forEach((viewPort) => {
      if(viewPort.viewportID == ViewPortID) {
        window.devStore.ShowPanel(viewPort.viewportID);
      } else {
        window.devStore.HidePanel(viewPort.viewportID);
      }
    });
  } else {
    viewPorts.forEach((viewPort) => {
      window.devStore.HidePanel(viewPort.viewportID);
    });
  }*/
}

function delRootMenu(params, callback) {
  httpRequest({
    method : 'POST',
    type : "application/json",
    url : sessionUrl + '/delmenu',
    data : data
  }, callback);
}

function httpRequest(params, callback) {
  const request = new XMLHttpRequest();
  request.addEventListener("load", () => {
    callback(null, request.responseText);
  });
  if(params.method == 'POST') {
    request.open(params.method, params.url);
    request.setRequestHeader("Content-Type", params.type);
    request.send(JSON.stringify(params.data));
  } else if(params.method == 'GET') {
    request.open(params.method, params.url+'?data='+JSON.stringify(params.data));
    request.setRequestHeader("Content-Type", params.type);
    request.send();
  }
}

function isMobile() {
        let check = false;
        //Mobile-only
        //(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        //Mobile+Tablets
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
}

export {
  getClientContext,
  getGrant,
  getContacts,
  getMeetings,
  httpRequest,
  addRootMenu,
  delRootMenu,
  openMenuItem,
  openClientContext,
  closeClientContext,
  openChildPanel
}
